import styled from 'styled-components'
import { space } from 'styled-system'

import { default as VARIABLES } from '../../themes/styles/variables'

export const ToastStyle = styled.div`
  /* Parent styles
  ------------------------------- */

  /* Child element styles
  ------------------------------- */
  .Toastify {
    position: relative;
    z-index: 999999;
    .Toastify__toast-container {
      display: flex;
      justify-content: center;
      flex-wrap: wrap;

      .Toastify__toast {
        min-height: 60px;
        min-width: 427px;
        box-shadow: 0 2px 5px ${VARIABLES.COLORS.SHADOW_1};
        border-radius: ${VARIABLES.BORDER_RADIUSES.XS};

        .Toastify__toast-body {
          text-align: center;
        }

        &.Toastify__toast--success {
          background-color: ${VARIABLES.COLORS.GREEN_1};
        }

        &.Toastify__toast--error {
          background-color: ${VARIABLES.COLORS.RED_3};
        }

        &.Toastify__toast--warning {
          background-color: ${VARIABLES.COLORS.YELLOW_1};
        }
      }
    }
  }

  /* Modifiers
  ------------------------------- */

  /* Media queries
  ------------------------------- */
`
